export function convertUTCtoLocalTime(utcTime: string | undefined): string {
  if (!utcTime) {
    return '';
  }

  const date = new Date(utcTime);

  return date.toLocaleTimeString(undefined, {
    hour12: true,
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function convertUTCtoLocalDate(utcTime: string | undefined): string {
  if (!utcTime) {
    return '';
  }

  const date = new Date(utcTime);

  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}
